/**
 * 业务接口根地址（来自 VITE_API_URL，可含路径前缀如 /translate）。
 * 其后直接拼接 /video、/system 等路径，不再使用 /admin-api 段。
 */
export function getApiOrigin(): string {
  return String(import.meta.env.VITE_API_URL ?? '')
    .trim()
    .replace(/\/+$/, '');
}

export function getSystemApiBase(): string {
  const origin = getApiOrigin();
  return origin ? `${origin}/system` : '/system';
}
